var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file dropdown
 * @author (zhuwanying02)
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { noop } from '../../common/util';
import DropdownBase from './DropdownBase';
import PopperWrap from '../PopperWrap';
import { classPrefix } from '../../common/util';

import _ from 'lodash-es';

import './Dropdown.less';

/*
 * 参数说明
 * mode                         非必需，['base', 'group']对应['基础模式', '分组模式']，二选一，不传入时默认为基础模式
 * optionData                   必需，可选项数据源，对象数组
 * onHandleChange               必需，选择完成后的回调，(value) => void
 * multiple                     非必需，是否为多选模式，true表示多选，默认为false，表示单选
 * width                        非必需，下拉框的宽度（默认为120px），数字或字符串
 * value                        非必需，下拉选中项，字符串或字符串数组，单选时为字符串，多选时为字符串数组
 * panelLocation                非必需，下拉框的位置，默认bl，具体含义参加Panel
 * className                    非必需，组件根元素上传入自定义类，字符串
 * zIndex                       非必须，弹出层的z-index值
 * onCloseByWindow              非必需，点击组件外区域的回掉
 * toggleDropdownVisible        非必需，点击dropdown包裹的组件回掉，函数入参为布尔值，代表下拉展示与收起状态
 * onlyBodyClickFoldDropdown    非必须，只有点击组件外的区域收起dropdown
 * isShowPanel                  非必需，控制dropdown展开状态
 * isShowTitle                  非必需，下拉是否鼠标悬浮显示默认title
 * preventOverflowEnabled     非必需,下拉是否受overflow碰撞影响
 * popupOnBody                可选,下拉是否挂在body上
 */

var Dropdown = function (_Component) {
    _inherits(Dropdown, _Component);

    function Dropdown(props) {
        _classCallCheck(this, Dropdown);

        var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

        _this.toggleDropdownVisible = _this.toggleDropdownVisible.bind(_this);
        _this.onCloseByWindow = _this.onCloseByWindow.bind(_this);

        _this.state = {
            isShowPanel: _this.props.isShowPanel
        };
        return _this;
    }

    _createClass(Dropdown, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(np) {
            if (!_.isEqual(np.isShowPanel, this.props.isShowPanel)) {
                this.setState({
                    isShowPanel: np.isShowPanel
                });
            }
        }
    }, {
        key: 'onCloseByWindow',
        value: function onCloseByWindow(e) {
            this.setState({
                isShowPanel: false
            });
            this.props.onCloseByWindow && this.props.onCloseByWindow(e);
        }
    }, {
        key: 'toggleDropdownVisible',
        value: function toggleDropdownVisible() {
            if (this.state.isShowPanel && this.props.onlyBodyClickFoldDropdown) {
                return;
            }
            this.props.toggleDropdownVisible && this.props.toggleDropdownVisible(!this.state.isShowPanel);
            this.setState({
                isShowPanel: !this.state.isShowPanel
            });
        }
    }, {
        key: 'popperNeedPlacement',
        value: function popperNeedPlacement(panelLocation) {
            switch (panelLocation) {
                case 't':
                    return 'top';
                case 'tl':
                    return 'top-start';
                case 'tr':
                    return 'top-end';
                case 'b':
                    return 'bottom';
                case 'bl':
                    return 'bottom-start';
                case 'br':
                    return 'bottom-end';
                case 'r':
                    return 'right';
                case 'rt':
                    return 'right-start';
                case 'rb':
                    return 'right-end';
                case 'l':
                    return 'left';
                case 'lt':
                    return 'left-start';
                case 'lb':
                    return 'left-end';
                default:
                    return 'right-start';
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                className = _props.className,
                children = _props.children,
                width = _props.width,
                panelLocation = _props.panelLocation,
                classPrefix = _props.classPrefix,
                zIndex = _props.zIndex,
                preventOverflowEnabled = _props.preventOverflowEnabled,
                popupOnBody = _props.popupOnBody;

            width < 120 && (width = 120);
            var dClass = classnames(className, _defineProperty({}, classPrefix + '-dropdown-root', true));

            return React.createElement(PopperWrap, {
                containerNode: React.createElement(
                    'div',
                    {
                        ref: function ref(el) {
                            _this2.dpContainer = el;
                        },
                        className: dClass
                    },
                    React.createElement(
                        'div',
                        { style: { display: 'inline-block' }, onClick: this.toggleDropdownVisible },
                        children
                    )
                ),
                popupNode: React.createElement(DropdownBase, _extends({}, this.props, {
                    width: width,
                    toggleDropdownVisible: this.toggleDropdownVisible,
                    classPrefix: classPrefix
                })),
                placement: this.popperNeedPlacement(panelLocation),
                isShowPopup: this.state.isShowPanel,
                onBodyClick: this.onCloseByWindow,
                popupNodeZIndex: zIndex,
                preventOverflowEnabled: preventOverflowEnabled,
                popupOnBody: popupOnBody
            });
        }
    }]);

    return Dropdown;
}(Component);

export default Dropdown;


Dropdown.defaultProps = {
    onHandleChange: noop,
    optionData: [],
    className: '',
    width: 120,
    multiple: false,
    value: '',
    mode: 'base',
    panelLocation: 'bl',
    isShowPanel: false,
    isShowTitle: true,
    classPrefix: classPrefix,
    preventOverflowEnabled: true
};

Dropdown.propTypes = {
    optionData: PropTypes.arrayOf(PropTypes.object).isRequired,
    onHandleChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    children: PropTypes.node,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    multiple: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    mode: PropTypes.oneOf(['base', 'group']),
    singleSelect: PropTypes.bool,
    panelLocation: PropTypes.string,
    zIndex: PropTypes.number,
    onCloseByWindow: PropTypes.func,
    toggleDropdownVisible: PropTypes.func,
    onlyBodyClickFoldDropdown: PropTypes.bool,
    isShowPanel: PropTypes.bool,
    isShowTitle: PropTypes.bool,
    classPrefix: PropTypes.string,
    preventOverflowEnabled: PropTypes.bool,
    popupOnBody: PropTypes.bool
};